import * as TYPES from '../types';
import { defaultDataEvent } from './init';
import { LIVE_PRACTICE, PAST_GAME } from '../../config/constants';

export const dataEvents = (state = {}, action) => {
  const newState = action.type === TYPES.UPDATE_PRACTICE_START_TIME ? JSON.parse(JSON.stringify(state)) : { ...state };

const setPracticeViewerState = (data, practiceId, teamOfInterest) => {
  const dataKey = teamOfInterest ? `data:${teamOfInterest}` : 'data';

  if (!newState[practiceId]) {
    newState[practiceId] = JSON.parse(
      JSON.stringify(defaultDataEvent(teamOfInterest))
    );
  }

  if (!newState[practiceId][dataKey]) {
    newState[practiceId][dataKey] = {};
  }

  if (!newState[practiceId][dataKey].practiceViewer) {
    newState[practiceId][dataKey].practiceViewer = {};
  }

  newState[practiceId][dataKey].practiceViewer = {
    ...newState[practiceId][dataKey].practiceViewer,
    ...data
  };

  return newState;
};

  switch (action.type) {
    case TYPES.UPDATE_META_DATA_EVENT:
      if (!newState[action.gameId]) {
        if (action.meta.type === PAST_GAME) {
          newState[action.gameId] = JSON.parse(JSON.stringify({ ...defaultDataEvent(action.meta.homeTeam.teamId), ...defaultDataEvent(action.meta.visitorTeam.teamId) }));
        } else {
          newState[action.gameId] = JSON.parse(JSON.stringify(defaultDataEvent()));
        }
      }
      newState[action.gameId].meta = newState[action.gameId].meta ? { ...newState[action.gameId].meta, ...action.meta } : { ...action.meta };
      if (!newState[action.gameId].mongoId) {
        newState[action.gameId].mongoId = action.meta._id;
      }
      return newState;
      case TYPES.UPDATE_LIVE_ALERTS_EVENT:
        if (!newState[action.gameId]) {
          newState[action.gameId] = JSON.parse(JSON.stringify(defaultDataEvent()));
        }
        newState[action.gameId].alerts = {...action.alerts};
        return newState;
    case TYPES.UPDATE_PRACTICES_DATA_EVENTS:
      return action.practices;
    case TYPES.REPLACE_HIGHLIGHTS_DATA_EVENT:
      if (!newState[action.gameId]) {
        newState[action.gameId] = JSON.parse(JSON.stringify(defaultDataEvent(action.teamOfInterest)));
      }
      newState[action.gameId][action.teamOfInterest ? ('data:' + action.teamOfInterest) : 'data'].highlights = action.highlights;
      return newState;
    case TYPES.REPLACE_ZONES_THRESHOLD:
      if (!newState[action.gameId]) {
        newState[action.gameId] = JSON.parse(JSON.stringify(defaultDataEvent(action.teamOfInterest)));
      }
      newState[action.gameId][action.teamOfInterest ? ('data:' + action.teamOfInterest) : 'data'].zones = action.zones;
      return newState;
    case TYPES.REPLACE_PLAYERS_DATA_EVENT:
      if (!newState[action.gameId]) {
        newState[action.gameId] = JSON.parse(JSON.stringify(defaultDataEvent(action.teamOfInterest)));
      }
      newState[action.gameId][action.teamOfInterest ? ('data:' + action.teamOfInterest) : 'data'].players = [...action.players];
      return newState;
    case TYPES.REPLACE_PLAYERS_SESSIONS_DATA_EVENT:
      if (!newState[action.gameId]) {
        newState[action.gameId] = JSON.parse(JSON.stringify(defaultDataEvent()));
      }
      newState[action.gameId].data.playersSessions = action.playersSessions;
      return newState;
    case TYPES.REPLACE_PLAYERS_BALL_METRICS_DATA_EVENT:
      if (!newState[action.gameId]) {
        newState[action.gameId] = JSON.parse(JSON.stringify(defaultDataEvent()));
      }
      newState[action.gameId][action.teamOfInterest ? ('data:' + action.teamOfInterest) : 'data'].playersBall = action.players;
      return newState;
    case TYPES.REPLACE_PLAYERS_BALL_METRICS_DATA_BY_ZONE_EVENT:
      if (!newState[action.gameId]) {
        newState[action.gameId] = JSON.parse(JSON.stringify(defaultDataEvent()));
      }
      newState[action.gameId][action.teamOfInterest ? ('data:' + action.teamOfInterest) : 'data'].playersBallByZone = action.data;
      return newState;
    case TYPES.REPLACE_MANAGE_DATA_EVENT:
      if (action.manage && action.gameId !== action.manage._id && newState.hasOwnProperty(action.manage._id)) {
        delete newState[action.manage._id];
      }
      if (!newState[action.gameId]) {
        newState[action.gameId] = JSON.parse(JSON.stringify(defaultDataEvent()));
      }
      newState[action.gameId].data.manage = { ...newState[action.gameId].data.manage, ...action.manage };
      /*if (action.manage.drills[0] && action.manage.drills[0].startTs) {
        newState[action.gameId].meta = {...newState[action.gameId].meta, startTime: action.manage.drills[0].startTs};
      } else {
        newState[action.gameId].meta = {...newState[action.gameId].meta, startTime: action.manage.start};
      }*/
      return newState;
    case TYPES.PATCH_MANAGE_DATA_EVENT:
      if (!newState[action.gameId]) {
        newState[action.gameId] = JSON.parse(JSON.stringify(defaultDataEvent()));
      }
      newState[action.gameId].data.manage = { ...newState[action.gameId].data.manage, ...action.manage };
      /*if (action.manage.drills[0] && action.manage.drills[0].startTs) {
        newState[action.gameId].meta = {...newState[action.gameId].meta, startTime: action.manage.drills[0].startTs};
      } else {
        newState[action.gameId].meta = {...newState[action.gameId].meta, startTime: action.manage.start};
      }*/
      return newState;
    case TYPES.REPLACE_MODAL_PLAYER_DATA:
      if (!newState[action.gameId]) {
        newState[action.gameId] = JSON.parse(JSON.stringify(defaultDataEvent()));
      }
      if (!newState[action.gameId].modalPlayers[action.playerId]) {
        newState[action.gameId].modalPlayers[action.playerId] = {};
      }
      newState[action.gameId].modalPlayers[action.playerId] = { ...newState[action.gameId].modalPlayers[action.playerId], ...action.modalPlayer };
      return newState;
    case TYPES.REPLACE_BALL_METRICS_MODAL_PLAYER_DATA:
      if (!newState[action.gameId]) {
        newState[action.gameId] = JSON.parse(JSON.stringify(defaultDataEvent()));
      }
      if (!newState[action.gameId].modalBallMetrics[action.playerId]) {
        newState[action.gameId].modalBallMetrics[action.playerId] = {};
      }
      newState[action.gameId].modalBallMetrics[action.playerId] = { ...newState[action.gameId].modalBallMetrics[action.playerId], ...action.modalBallMetric };
      return newState;
    case TYPES.REPLACE_VELOCITY_GRAPH_DATA:
      if (!newState[action.gameId]) {
        newState[action.gameId] = JSON.parse(JSON.stringify(defaultDataEvent()));
      }
      if (!newState[action.gameId].modalPlayers[action.playerId]) {
        newState[action.gameId].modalPlayers[action.playerId] = {};
      }
      newState[action.gameId].modalPlayers[action.playerId].velocityGraphData = action.velocityGraphData;
      return newState;
    case TYPES.CHANGE_TO_LIVE_PRACTICE:

      newState[action.newGameId] = JSON.parse(JSON.stringify(newState[action.oldGameId]));
      newState[action.newGameId].meta.type = LIVE_PRACTICE;
      newState[action.oldGameId]= {
        ...newState[action.oldGameId],
        validGameId: action.newGameId
      };
      return newState;
    case TYPES.UPDATE_PRACTICE_START_TIME:
      if (!newState[action.gameId]) {
        newState[action.gameId] = JSON.parse(JSON.stringify(defaultDataEvent()));
      }
      newState[action.gameId].data.manage = { ...newState[action.gameId].data.manage, ...action.manage };
      const startTime = action.manage && action.manage.drills && action.manage.drills[0] && action.manage.drills[0].startTs ? action.manage.drills[0].startTs : action.manage.start;
      newState[action.gameId].meta = { ...newState[action.gameId].meta, startTime: startTime };
      return newState;
    case TYPES.GET_PLAYER_BLINKS:
      return setPracticeViewerState({ blinks: action.blinks, hasBlinks: true }, action.practiceId, action.teamOfInterest);
    case TYPES.GET_PLAYERS_DATA:
      return setPracticeViewerState({ players: action.players }, action.practiceId, action.teamOfInterest);
    case TYPES.GET_PLAYERS_METRICS:
      return setPracticeViewerState({ metrics: action.metrics }, action.practiceId, action.teamOfInterest);
    case TYPES.SET_METRIC_CURRENT_SEC:
      return setPracticeViewerState({ metricSec: action.metricSec }, action.practiceId, action.teamOfInterest);
    case TYPES.NO_DATA_FOUNDED:
      return setPracticeViewerState({ errorMsg: action.errorMsg }, action.practiceId, action.teamOfInterest);
    case TYPES.GET_TEAM_FIELDS:
      return setPracticeViewerState({ fields: action.fields }, action.practiceId, action.teamOfInterest);
    case TYPES.FETCHED_DATA_FAILED:
      return setPracticeViewerState({ fetchTries: action.fetchTries }, action.practiceId, action.teamOfInterest);
    case TYPES.MAP_SHOULD_MOUNT:
      return setPracticeViewerState({ shouldMapMount: action.status }, action.practiceId, action.teamOfInterest);
    case TYPES.CLEAR_PLAYERS_TRACKS_DATA:
      return setPracticeViewerState({
        blinks: undefined,
        isFetching: false,
        errorMsg: '',
        fetchTries: undefined
      }, action.practiceId, action.teamOfInterest);
    case TYPES.ARE_TRACKS_FETCHING:
      return setPracticeViewerState({ isFetching: action.isFetching, reqSecs: action.reqSecs }, action.practiceId, action.teamOfInterest);
    case TYPES.CLEAR_TRACKS_DATA_ON_UNMOUNT:
      return setPracticeViewerState({ blinks: undefined, reqSecs: undefined, hasBlinks: false }, action.practiceId, action.teamOfInterest);
    case TYPES.CLEAR_PRACTICE_DATA:
      if (!newState[action.practiceId]) {
        newState[action.practiceId] = JSON.parse(JSON.stringify(defaultDataEvent()));
      }
      newState[action.practiceId].data.practiceViewer = {};
      return newState;
    default:
      return state;
  }
};
